export default __webpack_public_path__ + "static/media/slider_1_eng.1877ce75.png";